import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import {
  ButtonModule,
  CommonWordingModule,
  DateSelectionModule,
  FormsModule,
  icoCalendarDuo,
  IconsModule,
  LoadingIndicatorModule,
  TemplateVariablesModule
} from '@platform-frontend/ui-tools';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { ShoppingCartConfiguratorComponent } from './shopping-cart-configurator.component';

@NgModule({
  declarations: [ShoppingCartConfiguratorComponent],
  exports: [ShoppingCartConfiguratorComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    DateSelectionModule,
    FormsModule,
    IconsModule.withIcons(icoCalendarDuo),
    LoadingIndicatorModule,
    MatomoTrackClickDirective,
    ReactiveFormsModule,
    TemplateVariablesModule,
    TranslocoModule
  ]
})
export class ShoppingCartConfiguratorModule {}
